import { z, ZodType } from 'zod'

export interface VatSuggestionFormRow {
  isApproved: boolean
  isRejected: boolean
  suggestedTaxRateId: string
}

export interface VatSuggestionsForm {
  [rowId: string]: VatSuggestionFormRow
}

export type VatSuggestionsFormSchema = ZodType<VatSuggestionsForm>

export const vatSuggestionsFormSchema: VatSuggestionsFormSchema = z.record(
  z.string(),
  z.object({
    isApproved: z.boolean(),
    isRejected: z.boolean(),
    suggestedTaxRateId: z.string(),
  }),
)
